import { render, staticRenderFns } from "./YlorganizationTwo.vue?vue&type=template&id=40ee67dc&scoped=true&"
import script from "./YlorganizationTwo.vue?vue&type=script&lang=ts&"
export * from "./YlorganizationTwo.vue?vue&type=script&lang=ts&"
import style0 from "./YlorganizationTwo.vue?vue&type=style&index=0&id=40ee67dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ee67dc",
  null
  
)

export default component.exports